export const IS_VIEWING_READABILITY_SCORES_MODAL =
  'IS_VIEWING_READABILITY_SCORES_MODAL'
export const IS_NOT_VIEWING_READABILITY_SCORES_MODAL =
  'IS_NOT_VIEWING_READABILITY_SCORES_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'
export const SHOW_MODAL = 'SHOW_MODAL'

export function isViewingReadabilityScoresModal(section, subsection) {
  return {
    type: IS_VIEWING_READABILITY_SCORES_MODAL,
    payload: {
      section: section,
      subsection: subsection
    }
  }
}

export function isNotViewingReadabilityScoresModal() {
  return {
    type: IS_NOT_VIEWING_READABILITY_SCORES_MODAL
  }
}

export function showModal(modalType, modalProps) {
  return {
    type: SHOW_MODAL,
    payload: {
      modalType,
      modalProps
    }
  }
}

export function hideModal() {
  return {
    type: HIDE_MODAL
  }
}



// WEBPACK FOOTER //
// ./src/actions/modal.js